export default __webpack_public_path__ + "static/media/bonfire.a83339ba.png";